export const content = {
  api: 'contentManagerEndpoint/getContent',
};
